import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import { TableRow, TableCell, Button } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEllipsisH } from '@fortawesome/pro-solid-svg-icons'

const useStyles = makeStyles({
  loadingMetricLong: {
    width: 153,
    borderRadius: 21,
  },
  loadingMetricShort: {
    width: 48,
    borderRadius: 21,
  },
})

const LoadingRow = ({ index, columnCount }) => {
  const classes = useStyles()
  const filler = []
  for (let i = 0; i < columnCount - 1; i++) {
    filler.push(
      <TableCell
        key={i}
        align="right"
      >
        <Skeleton className={classes.loadingMetricShort} />
      </TableCell>,
    )
  }

  return (
    <TableRow index={index}>
      <TableCell component="th">
        <Skeleton className={classes.loadingMetricLong} />
      </TableCell>
      {filler}
      <TableCell align="right">
        <Button style={{ justifyContent: 'flex-end' }}>
          <FontAwesomeIcon icon={faEllipsisH} />
        </Button>
      </TableCell>
    </TableRow>
  )
}

LoadingRow.propTypes = {
  index: PropTypes.number.isRequired,
  columnCount: PropTypes.number.isRequired,
}

export default LoadingRow
